(function () {
    var GAME_ID = "Aol";

    var GAME_CONFIG = {
        global: {
            lang: "ru",
            debug: "true",
            jsServerName: "social",
            playerElementId: "playerCanvas",
            pageWidth: 1000,
            pageHeight: 832,
            preloaderPath: "preloader.swf",
            requiredFlashVersion: "10.0"
        },
        Aol: {
            common: {
                preloaderPath: "aol-preloader.swf",
                htmlClassName: 'AoLJS',
                requiredFlashVersion: "11.4",
                pageHeight: 830,
                shareButtonTitle: L10N.getString("LIKE_BUTTON_TITLE"),
                shareButtonDescription: L10N.getString("LIKE_BUTTON_DESCRIPTION"),
                hideShareButton: true,
                addShareButtonTab: true,
                showTitleTab: true,
                showFaq: false,
                showInviteTab: true,
                flashWindowMode: 'direct',
                // Use string representation to allow override at getFormParameters()
                swfPlayerAvailable: getUserAgentVersion("Chrome") < 76
                    ? 'true'
                    : 'false'
            },
            Local: {
                hideShareButton: false
            },
            Facebook: {
                hideShareButton: false
            },
            // VK Mini Apps (vk-bridge) platform: no Flash in the iframe,
            // the same adapter serves Odnoklassniki (vk_client=ok)
            Vkontakte: {
                player: 'HTMLPlayer',
                swfPlayerAvailable: 'false',
                hideShareButton: true
            },
            Odnoklassniki: {
                player: 'HTMLPlayer',
                swfPlayerAvailable: 'false',
                hideShareButton: true
            },
            Abyss: {
                showInviteTab: false
            },
            Y8: {
                showInviteTab: false
            },
            ArmorGames: {
                showInviteTab: false
            },
            R2Games: {
                showInviteTab: false
            }
        }
    };

    function getFormParameters() {
        var result = {};
        $("form[name=SIG] input").each(function (i, input) {
            result[input.name] = input.value;
        });
        return result;
    }

    function getConfigParameters(config, gameId, socialId) {
        config = config || {};
        var globalConfig = config.global || {};
        var gameConfig = config[gameId] || {};
        var commonConfig = gameConfig.common || {};
        var socialConfig = gameConfig[socialId] || {};
        return $.extend({}, globalConfig, commonConfig, socialConfig);
    }

    function main(parameters) {

        var lang = parameters.lang;
        var socialName = parameters.social;
        var jsRoot = parameters.jsRoot;
        var playerName = parameters['player'] || 'SWFPlayer';
        var playerConfig;
        if (playerName === 'mixed') {
            playerConfig = PlayerConfig(getUserAgentVersion('Chrome') < 76 ? 'SWFPlayer' : 'HTMLPlayer');
            playerName = playerConfig.getPlayerName();
        }
        var /** @type {Player} */ player = {
            SWFPlayer: SWFPlayer,
            HTMLPlayer: HTMLPlayer
        }[playerName] || SWFPlayer;

        $('<link rel="stylesheet" />').attr('href', jsRoot + 'default.min.css').appendTo('head');
        $('body').addClass(socialName).addClass('lang-' + lang);
        $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1">')

        L10N.setLang(lang);

        var stat = window.SIGStat = new Stat(parameters);
        stat.trackJsLoaded();
        stat.trackPlayerRuns(playerName);

        var game = Game(parameters);
        game.showLoading();
        game.hideGame();
        if (player === HTMLPlayer && parameters.swfPlayerAvailable === 'true') {
            game.setLoadingNotice(L10N.getString('SWF_PLAYER_FALLBACK_NOTICE'));
        }

        var gameLayout = new TabsLayout();
        if (parameters.showTitleTab) {
            gameLayout._tabs.prepend('<li class="title"><span>' + L10N.getString("GAME_NAME") + '</span></li>');
        }

        gameLayout.addTab('game', L10N.getString("GAME"), game);
        if (playerConfig) {
            gameLayout.addButtonTab('playerConfig',
                L10N.getString(playerName === 'SWFPlayer' ? 'SWITCH_TO_HTML_PLAYER' : 'SWITCH_TO_SWF_PLAYER'),
                function () {
                    playerConfig.setAndReload(playerName === 'SWFPlayer' ? 'HTMLPlayer' : 'SWFPlayer');
                });
        }
        if (parameters.supportUrl) {
            gameLayout.addIframeTab('support', L10N.getString("SUPPORT"), parameters.supportUrl);
        }
        if (parameters.showFaq) {
            gameLayout.addIframeTab('faq', L10N.getString("FAQ"), jsRoot + 'faq.' + lang + '.html');
        }
        if (parameters.communityUrl) {
            gameLayout.addLinkTab('community', L10N.getString("COMMUNITY"), parameters.communityUrl);
        }
        if (parameters.showInviteTab) {
            gameLayout.addButtonTab('invite', L10N.getString("ACTION_INVITE"), function () {
                Social.instance.inviteFriends();
            });
        }

        gameLayout.openTab('game');
        var gameElement = $('#game');
        if (!gameElement.length) {
            gameElement = $('body');
        }
        gameElement.append(gameLayout.getObject());
        gameElement.append('<div class="bottom-border"></div>');
        gameElement.append('<p class="yourId">' + L10N.getString("YOUR_ID") + ': ' + parameters.userId + '</p>');

        var announcement = $("#announcement");
        if (announcement.length) {
            gameElement.append($('<div class="announcement"></div>').append(announcement));
            announcement.show();
        }

        if (parameters && parameters.bannerUrl && parameters.bannerSrcUrl) {
            gameElement.append(
                '<p class="banner">' +
                '<a href="' + parameters.bannerUrl + '" target="_blank">' +
                '<img src="' + parameters.bannerSrcUrl + '">' +
                '</a>' +
                '</p>'
            );
        }

        parameters.game = game;

        function embedGame() {

            stat.trackSocialLoaded();

            if (!parameters.hideShareButton) {
                gameLayout._tabs.append('<li id="likeButton"></li>');
                insertLikeButton(parameters, '#likeButton');
            }

            player.embed(parameters, parameters, function (error) {
                if (error && error.isEnableFlash) {
                    game.replaceGame(FPDialog());
                } else if (error) {
                    stat.trackFlashEmbedFail(error.message);
                    game.shutdown(error.message, error.actions);
                } else {
                    game.hideLoading();
                    game.showGame();
                }
            });

            if (parameters.add101XpBanner) {
                $.getScript(location.protocol + '//banners.101xp.com/scripts/embed.js?v=3', function () {
                    gameElement.prepend('<div id="banner-example" style="margin:5px 0;"></div>');
                    new XPBannerEmbed(36, "banner-example");
                });
            }
        }

        var social = new ScriptSocial(parameters);
        if (social.isReady) {
            embedGame();
        } else if (social.isFailed) {
            game.shutdown(L10N.getString("ERROR_SOCIAL") + " (" + social.isFailed + ")");
        } else {
            social.ready(embedGame);
            social.failed(function (reason) {
                game.shutdown(L10N.getString("ERROR_SOCIAL") + " (" + reason + ")");
            });
        }
    }

    function executeMain() {
        var formParameters = getFormParameters();

        var configParameters = getConfigParameters(GAME_CONFIG, GAME_ID, formParameters.social);
        var injectedParameters = window.SIG_injected_params ? window.SIG_injected_params : {};

        var parameters = $.extend({},
            configParameters,
            formParameters,
            injectedParameters);

        main(parameters);
    }

    if (window.SIG_injected) {
        function injected_cb(inject) {
            if (!inject) {
                executeMain();
                return;
            }
            var p = window.SIG_injected_params;
            window.SIG_injected = false;
            if (!p.jsRoot) {
                executeMain();
                return;
            }
            var newUrl = p.jsRoot + 'index.' + getFormParameters()['social'] + '.min.js';
            var oldUrl = $('#indexJs').attr('src');
            if (newUrl !== oldUrl) {
                $.getScript(newUrl);
            } else {
                executeMain();
            }
        }

        if (window.SIG_injected_params) {
            injected_cb(true);
        } else {
            window.SIG_injected_cb = injected_cb;
        }

    } else {
        executeMain();
    }

})();